import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class SubsidiaryContractService {
  constructor(private coreService: CoreService) { }
  // get cuntract
  getCustomerContractList(params: any, pageIndex: number = 0, pageSize: number = 0): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.contract.getCustomerContractList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)
        .append('Id', params && params.Id ? params.Id : '')
        .append('Title', params && params.Title ? params.Title : '')
        .append('ContractNumber', params && params.ContractNumber ? params.ContractNumber : '')
        .append('ContractNumberAttachment', params && params.ContractNumberAttachment ? params.ContractNumberAttachment : '')
        .append('CustomerId', params && params.CustomerId ? params.CustomerId : '')
        .append('ContractDateStart', params && params.ContractDateStart ? params.ContractDateStart : '')
        .append('ContractDateEnd', params && params.ContractDateEnd ? params.ContractDateEnd : '')
        .append('StartDate', params && params.StartDate ? params.StartDate : '')
        .append('EndDate', params && params.EndDate ? params.EndDate : '')
    );
  }


  customerContractAddRoom(command: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.subsidiary.contract.customerContractAddRoom,
      command,
      new CommonHttpOption().headers
    );
  }
  // add contract
  customerContractAdd(command: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.subsidiary.contract.customerContractAdd,
      command,
      new CommonHttpOption().headers
    );
  }

  // edit contract
  customerContractEdit(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.contract.customerContractEdit,
      command,
      new CommonHttpOption().headers
    );
  }
  // delete customerContrac
  customerContractDelete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.subsidiary.contract.customerContractDelete,
      new CommonHttpOption().headers,
      data
    );
  }
  // get ContractTermInfo
  customerContractTermInfoList(params: any): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.contract.customerContractTermInfoList + params.Id,
      new CommonHttpOption().headers
    );
  }

  // add contract
  customerContractTermInfoAdd(command: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.subsidiary.contract.customerContractTermInfoAdd,
      command,
      new CommonHttpOption().headers
    );
  }
  // delete ContractTermInfo
  customerContractTermInfoDelete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.subsidiary.contract.customerContractTermInfoDelete,
      new CommonHttpOption().headers,
      data
    );
  }

  changeCustomerContractPersonAddState(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.subsidiary.contract.ChangeCustomerContractPersonAddState,
      data,
      new CommonHttpOption().headers
    );
  }

}
